module.exports = __webpack_public_path__ + "static/img/other-duoxuanti.586ab0a5.png";